import React, { Fragment, useMemo, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { PDFDocument } from 'pdf-lib';

import Loader from "../Loader/Loader.jsx";
import PdfToTextAction from "./PdfToTextAction.jsx";
import PdfToTextResult from "./PdfToTextResult.jsx";
import PdfToTextFileSelect from "./PdfToTextFileSelect.jsx";
import PdfToTextFileUpload from "./PdfToTextFileUpload.jsx";
import PdfToTextAbout from "./PdfToTextAbout.jsx";
import PdfToTextSocket from "./PdfToTextSocket.jsx";

import { useStore } from "../../hook-store/store.js";
import { getPdfToTextConfig } from "../../utils/ollama/pdf-file.js";

import { ollamaNodeJsUrl } from "../../App.js";

import { marks } from "../../utils/marks.jsx";
import "./PdfToText.css";


let pdfViewEl

export default function PdfToText(props) {
    const { } = props;

    const [t] = useTranslation("translation");

    const hiddenFileSelect = useRef(null);
    
    const [store, dispatch] = useStore();
    // const { 
    // } = store.mlSpeechStore;

    const [inputPdfFile, setInputPdfFile] = useState();
    const [pdfMetadata, setPdfMetadata] = useState({});
    const [pdfTextData, setPdfTextData] = useState();
    const [outputTextFile, setOutputTextFile] = useState();
    const [outputText, setOutputText] = useState('');
    const [showPdfView, setShowPdfView] = useState(true);
    const [pdfToTextConfig, setPdfToTextConfig] = useState();
    const [showPageAbout, setShowPageAbout] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const uploadApp = 'pdfToText';

    // console.log(pdfMetadata)
    useEffect(() => {
      getPdfToTextConfigHandler();

      window.scrollTo(0,0);
    },[]);

    // useEffect(() => {
    //   if (inputPdfFile) {
    //     pdfReadHandler(inputPdfFile);
    //     // setShowPdfView(false);  
    //   }
    // },[inputPdfFile]);

    useMemo(() => {
      if (inputPdfFile) {
        let iframeHeight = 500;
        if (window.innerHeight < iframeHeight) {
          iframeHeight = parseInt(window.innerHeight * 0.9);
        }

        pdfViewEl = (
            <div>
              <iframe
                src={URL.createObjectURL(inputPdfFile)}
                title="PDF Viewer"
                width="100%"
                // height="80%"
                // height="500px"
                height={`${iframeHeight}px`}
                // style={{border: "3px solid red"}}
                // style={{ border: 'none' }}
              />
              <div>
                <span
                  onClick={() => {
                    setShowPdfView(false);
                  }}
                >
                  {t('pdfToText05','Hide pdf file contents')} 
                  {' '}{marks.triangle}
                </span>
              </div>
            </div>
        );
      }
      }, [inputPdfFile]);
    // console.log(inputPdfFile);
    
    // const handleInputClick = (event) => {
    //   hiddenFileSelect.current.click()
    // };

    // const setInputPdfFileHandler = (event) => {
    //   const file = event.target.files[0];
    //   // console.log('file', file);
    //   if (file && file.type === 'application/pdf') {
    //     setInputPdfFile(event.target.files[0]);
    //   } 
    // }

    const pdfReadHandler = async (pdfFile) => {
      try {
        setIsLoading(true);

        const res = await fetch(URL.createObjectURL(pdfFile));
        const arrayBuffer = await res.arrayBuffer();
        const pdfDoc = await PDFDocument.load(
          arrayBuffer,
          { 
            ignoreEncryption: true 
          }
        );
                
        // const pdfDoc = await PDFDocument.load(pdfFile);

        console.log(pdfDoc);

        const pages = pdfDoc.getPages();

        if (pages.length > 0) {
          setInputPdfFile(pdfFile);
          setPdfMetadata({
            ...pdfMetadata,
            pageCount: pages.length,
          })
          setShowPdfView(true);
          console.log(pages)
        }

        // 3. Use getter methods to retrieve metadata
        console.log("--- PDF Metadata ---");
        console.log("Title: ", pdfDoc.getTitle());
        console.log("Author: ", pdfDoc.getAuthor());
        console.log("Subject: ", pdfDoc.getSubject());
        console.log("Keywords: ", pdfDoc.getKeywords());
        console.log("Creator: ", pdfDoc.getCreator());
        console.log("Producer: ", pdfDoc.getProducer());
        console.log("Creation Date: ", pdfDoc.getCreationDate());
        console.log("Modification Date: ", pdfDoc.getModificationDate());
        console.log("Number of pages: ", pdfDoc.getPageCount());
        console.log("--------------------");

        setIsLoading(false);

      } catch(err) {
        console.log(err);
        setIsLoading(false);
        throw err;
      }
    };


    const getPdfToTextConfigHandler = async (pdfFile) => {
      try {
        setIsLoading(true);

        const resData = await getPdfToTextConfig(
          ollamaNodeJsUrl,
          localStorage.getItem('token'),
        );

        if (resData.data && resData.data.pdfToTextConfig) {
          setPdfToTextConfig(resData.data.pdfToTextConfig);
        }

        setIsLoading(false);

      } catch(err) {
        setIsLoading(false);
        throw err;
      }
    };

      let bannerElement;

      if (window.innerWidth <= 450) {
        bannerElement = (
          <iframe id="kura-text-audio-tools.spaceeight.net-1725583665876"
              style={{width:"310px", height:"70px", border:"none"}}  
              src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583665876"
          />
        );
      }

      if (window.innerWidth > 450 && window.innerWidth <= 768) {
        bannerElement = (
          <iframe id="kura-text-audio-tools.spaceeight.net-1725583679744"
          style={{width:"460px", height:"95px", border:"none"}}  
          src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583679744"
          />
        )
      }

      if (window.innerWidth > 768) {
        bannerElement = (
          <iframe id="kura-text-audio-tools.spaceeight.net-1725583699146"
              style={{width:"610px", height:"135px", border:"none"}}  
              src="https://adnetwork-adserviceadpage.spaceeight.net?adPlaceId=kura-text-audio-tools.spaceeight.net-1725583699146"
          />
        );
      }



    let pdfToTextBody;

    pdfToTextBody = (
      <div>
        <div 
          style={{
              display: 'flex',
              justifyContent: "center",
              paddingTop: "1rem",
              paddingBottom: "2rem"
          }}
          >
            {bannerElement}
        </div>

        <div className="pdfToText">
          <div className="pdfToTextTitle">
            PDF to Text
            {' '}
            <span
              style={{color: "gray"}}
              onClick={() => {
                setShowPageAbout(!showPageAbout);
              }}
            >
              {marks.questionCircleOMark}
            </span>
          </div>
          
          {showPageAbout && (
            <div className="pdfToTextAbout">
              <PdfToTextAbout />
            </div>
          )}

          <PdfToTextFileSelect 
            inputPdfFile={inputPdfFile}
            setInputPdfFile={setInputPdfFile}
            pdfReadHandler={pdfReadHandler}
            isLoading={isLoading}
          />
        

          {inputPdfFile && (
            <div>
              {/* {isLoading && (
                <Loader />
              )} */}
              <div className="pdfToTextRow">
                <div>
                  <strong
                    onClick={() => {
                      setShowPdfView(!showPdfView)
                    }}
                  >
                    {t('pdfToText04','Display pdf file contents')}
                    {' '}{marks.filePdfOMark} {marks.triangleDown}
                  </strong>
                </div>
                {/* {showPdfView && (
                  <div
                    style={showPdfView ? { display: "block"} : { display: "none"}}
                  >
                    {pdfViewEl}
                  </div>
                )} */}
                  <div
                    style={showPdfView ? { display: "block" } : { display: "none"}}
                  >
                    {pdfViewEl}
                  </div>
              </div>

              <PdfToTextAction 
                inputPdfFile={inputPdfFile}
                setPdfTextData={setPdfTextData}
                pdfMetadata={pdfMetadata}
                setIsLoading={setIsLoading}
                pdfToTextConfig={pdfToTextConfig}
                uploadApp={uploadApp}
                isLoading={isLoading}
                // pdfTextData={pdfTextData}
              />

              <PdfToTextResult 
                pdfTextData={pdfTextData}
                outputTextFile={outputTextFile}
                setOutputTextFile={setOutputTextFile}
                outputText={outputText}
                setOutputText={setOutputText}
                isLoading={isLoading}
              />

              <PdfToTextFileUpload 
                outputText={outputText}
                outputTextFile={outputTextFile}
                inputPdfFile={inputPdfFile}
                uploadApp={uploadApp}
              />
            </div>
          )}

          <PdfToTextSocket 
            uploadApp={uploadApp}
          />
        </div>
      </div>
    );

    return (
        <Fragment>
          <div>{pdfToTextBody}</div>
        </Fragment>
    );
  };
